const getDisqusUtils = () => import(
  /* webpackChunkName: "disqusUtils" */
  'utils/disqus'
);

/**
 * Initialize disqus embed.js.
 */
if (! window.DISQUS && document.getElementById('disqus_thread')) {
  Promise.all([
    getDisqusUtils(),
  ]).then((loadedModules) => {
    const { disqusUtils = null } = loadedModules[0];

    if (disqusUtils && disqusUtils.addScript) {
      disqusUtils.addScript('kauffmanorg', 'disqus.com', + new Date());
    }
  });
}
